import { Box, FormControl, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import React, { Dispatch } from 'react';

import { useCustomTheme } from '../../../../../../../../hooks/useCustomTheme';
import { Font } from '../../../../../../../shared/components/Font';
import { Text } from '../../../../../../../shared/components/Text';
import { getCommentChannelIcon } from '../../../../../utils/getCommentChannelIcon';

interface ChannelSelectorProps {
  existingChannels: string[];
  selectedChannels: string[];
  setSelectedChannels: Dispatch<React.SetStateAction<string[]>>;
}

export const ChannelSelector = ({ existingChannels, selectedChannels, setSelectedChannels }: ChannelSelectorProps) => {
  const { palette, customBorderRadius } = useCustomTheme();

  const styleDefinition = {
    root: {
      '& .MuiFilledInput-underline:before': {
        content: 'none',
      },
      '& .MuiFilledInput-underline.Mui-focused:after': {
        content: 'none',
      },
      '& .MuiFilledInput-input': {
        padding: '10px 12px',
        minHeight: '40px',
      },
      '& .MuiTypography-root': {
        overflow: 'hidden',
        maxWidth: '260px',
        textOverflow: 'ellipsis',
      },

      '& .MuiSelect-root': {
        background: palette.grey[50],
        borderRadius: customBorderRadius.paper,
        display: 'flex',
      },
      '& .MuiFilledInput-root': {
        height: '56px',
        borderRadius: customBorderRadius.paper,
      },
      '& .MuiSelect-icon': {
        color: palette.text.primary,
      },
    },
  };
  const useStyles = makeStyles(styleDefinition);

  const classes = useStyles();
  return (
    <FormControl className={classes.root} variant="filled">
      <InputLabel shrink>
        <Font variant={'overline'} color={'textSecondary'}>
          <Text tId={'SELECTED_CHANNELS'} />
        </Font>
      </InputLabel>
      <Select
        style={{ minWidth: '180px' }}
        multiple={true}
        value={selectedChannels}
        onChange={(e) => setSelectedChannels(e.target.value)}
        renderValue={(selected: string[]) => (
          <Box display={'flex'} alignItems={'end'}>
            <Font variant={'h5'} color="title">
              {selected.join(', ')}
            </Font>
          </Box>
        )}
      >
        {existingChannels.map((channel) => (
          <MenuItem value={channel} key={channel}>
            <Box display={'flex'} flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'}>
              <i className={'material-icons-outlined'} style={{ fontSize: '16px' }}>
                {getCommentChannelIcon(channel)}
              </i>
              <Font variant={'subtitle2'} color={'textSecondary'} style={{ marginLeft: '6px' }}>
                {channel}
              </Font>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
